import { createFileRoute, redirect } from "@tanstack/react-router";
import z from "zod";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { FeedbackForm } from "@/components/forms/FeedbackForm";
import { createSEOHead, SEO_DATA } from "@/lib/seo";

const searchSchema = z.object({
  bookingId: z.number().min(1),
});

export const Route = createFileRoute("/(public)/avis")({
  validateSearch: (search) => {
    const result = searchSchema.safeParse(search);
    if (!result.success) {
      return { bookingId: undefined };
    }
    return result.data;
  },
  beforeLoad: ({ search }) => {
    if (!search.bookingId) {
      throw redirect({
        to: "/",
      });
    }
  },
  head: () => createSEOHead(SEO_DATA.REVIEWS),
  component: RouteComponent,
});

function RouteComponent() {
  const { bookingId } = Route.useSearch();

  return (
    <div className="container mx-auto py-8 px-4">
      <Card className=" mx-auto max-w-md">
        <CardHeader>
          <CardTitle>Donner votre avis</CardTitle>
          <CardDescription>
            Partagez votre expérience avec votre chef à domicile
          </CardDescription>
        </CardHeader>
        <CardContent>
          <FeedbackForm bookingId={bookingId!} />
        </CardContent>
      </Card>
    </div>
  );
}
